import { render, staticRenderFns } from "./image-crop-organization.vue?vue&type=template&id=331a8d99&scoped=true&"
import script from "./image-crop-organization.vue?vue&type=script&lang=js&"
export * from "./image-crop-organization.vue?vue&type=script&lang=js&"
import style0 from "./image-crop-organization.vue?vue&type=style&index=0&id=331a8d99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a8d99",
  null
  
)

export default component.exports